module.exports = __webpack_public_path__ + "img/treasuries-transactions.a114fa16.svg";